import { useQueryClient } from "@tanstack/react-query";
import type { FC } from "react";
import HardwareIcon from "../../../assets/Icon-Red_Hat-Circuit-A-Red-RGB.png";
import type { IPartnershipStatus } from "../../../constants/apiconstants-pfs";
import type { DragHandleProps } from "../../../constants/CardsStructure";
import Env from "../../../utils/env";
import { DashboardCard } from "../shared/DashboardCard";

export const HardwareCard: FC<{ dragHandleProps?: DragHandleProps | undefined }> = ({ dragHandleProps }) => {
	const queryClient = useQueryClient();
	const partnershipStatus = queryClient.getQueryState(["partnershipStatus"])?.data as IPartnershipStatus;
	if (!partnershipStatus?.hardwarePartner) return null;
	return (
		<DashboardCard
			icon={HardwareIcon}
			title="Hardware certification"
			description="Access tools to certify your hardware systems, appliances and components with Red Hat platforms"
			footerLinks={[
				{
					label: "View certification cases",
					href: `${Env.RHCERTURLs[Env.getEnvName()]}certifications#/?ecosystem=hardware`,
				},
				{ label: "Create new certification case", href: `${Env.RHCERTURLs[Env.getEnvName()]}?source=external` },
			]}
			dragHandleProps={dragHandleProps}
		/>
	);
};
